var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApplication = function SvgApplication(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.557 8.792 3.7-2.775v11.101H2.754V6.017l3.7 2.775 5.552-5.55zm-5.215.153a.362.362 0 0 0-.673 0l-.182.437a3.12 3.12 0 0 1-1.61 1.664l-.512.228a.38.38 0 0 0 0 .689l.543.242a3.12 3.12 0 0 1 1.587 1.61l.177.405c.13.295.539.296.668 0l.176-.405a3.12 3.12 0 0 1 1.586-1.61l.544-.242a.38.38 0 0 0 0-.689l-.512-.228a3.12 3.12 0 0 1-1.61-1.664zM21.257 18.439H2.754v1.85h18.503z"
  })));
};
export default SvgApplication;